import { Button, SelectChangeEvent, styled } from '@mui/material';
import React, { useEffect, useRef, useState } from 'react'
import BorderHeading from '../../components/heading/BorderHeading';
import ConfigurationHeader from '../../components/heading/ConfigurationHeader';
import { CameraImage, DashboardCheckbox, DashboardSelect } from '../../components/Input/Input';
import { GenericPopUp } from '../../components/popup/genericPopUp';
import { convertValuesToConfig, createValidation, doFinalConfigSubmit, getMetaDataConfig, getNewConfiguration, overWriteConfig, postConfiguration, updateConfiguration } from '../../services/uiConfigService';
import { NameValidation, configurationAttributeType, newConfigurationNames, themeConfigurationValuesTypes } from '../../types';
import { appValueTypes, popupType } from '../../types/types';
import Input from "../../components/Input/Input"
import "./AppConfiguration.css";
import * as yup from 'yup';
import store from '../../stateManagement/store';
import * as Sentry from "@sentry/react";
import { IndentWrapper } from '../orderConfiguration/OrderConfiguration';
import QuestionHeading from '../../components/heading/QuestionHeading';
import { createBlobKey } from '../../utils/utils';
import { validateWithOtp } from '../../stateManagement/actions/validateOtpPopupActions';
import { HexColorPicker } from 'react-colorful';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faEyeDropper } from '@fortawesome/free-solid-svg-icons';
import { manageUpdateAccessObj } from '../manageUpdateAccess/manageUpdateAccessTypes';
import { openPopup } from '../../stateManagement/actions/popupActions';
import { defaultAppInputValues } from '../defaultConfigurations/appConfigDefaultValues';
import { deepClone } from '@mui/x-data-grid/utils/utils';
import ImportConfig from '../../components/importConfig/ImportConfig';
import ConfigComparePopup from '../../components/popup/ConfigComparePopup';
import { TranslationEnum, usePortalTranslation } from '../../providers/TranslationProvider';



const AppConfiguration = (props:{showBackButton?:boolean}) => {
    const [appConfig, setAppConfig] = useState<configurationAttributeType[]>([]);
    const [values, setValues] = useState<appValueTypes>(deepClone(defaultAppInputValues))
    const [appValidationsSchema, setAppValidationSchema] = useState({})
    const [appIcon, setAppIcon] = useState<string | File>()
    const [poweredByLogo, setPoweredByLogo] = useState<string | File>()
    const [clientHeaderLogo, setClientHeaderLogo] = useState<string | File>()
    const [clientLogo, setClientLogo] = useState<string | File>()
    const [loginBanner, setLoginBanner] = useState<string | File>()
    const [loaderGIF, setLoaderGIF] = useState<string | File>()
    const [appbarBackgroundImage, setappbarBackgroundImage] = useState<string | File>()
    const [loadingBackgroundImage, setLoadingBackgroundImage] = useState<string | File>()
    const [showConfigPopup,setShowConfigPopup] = useState<boolean>(false);
    const curConfigRef = useRef<{[key:string]:any[]}>({});
    const newConfigRef = useRef<{[key:string]:any[]}>({});
    const showColorStyle = (color: string) => { return { backgroundColor: color ? color.includes("#") ? color : "#" + color : "transparent", width: "3rem", height: "1.8rem", borderRadius: '0.2rem', marginLeft: '1rem' } }
    const [toggleColorInput, setToggleColorInput] = useState({
        solidAppBarColor: true,
        gradientAppBarColor: true,
        themeColor: true,
      });
    

      const [inputColor, setInputColor] = useState({
        solidAppBarColor: '',
        gradientAppBarColor: '',
        themeColor: '',
      });

      interface WrapperProps extends React.HTMLAttributes<HTMLDivElement> {
        callback?: Function
      }
    
      const Picker = (props: WrapperProps) => {
    
        const Wrapper = styled('span')(`
          width:2.5rem!important;
          padding-top:1rem;
          padding-bottom:1rem;
          border:#a2a9b0 solid 1px;
          display:flex;
          justify-content:center;
          align-items:center;
          border-radius:0.15rem
          `)
        return <Wrapper {...props}><FontAwesomeIcon color='#a2a9b0' icon={faEyeDropper} /></Wrapper>
      }
      const getAppConfiguration = async () => {
          try {
              const resp = await getNewConfiguration('app_configuration');
              const app_config: configurationAttributeType[] = resp?.domainValues ?? [] ;
              curConfigRef.current.app_configuration = app_config;
              setAppConfig([...app_config])
          } catch (err) {
              // Sentry.captureException(err);
          }
      }

    useEffect(() => {
        getAppConfiguration();
    }, [])

    const saveConfiguration = async (preview?: boolean) => {
            try {
                const resultantValues = { ...values };
                if (clientLogo) {
                    const fileArr = [];
                    clientLogo && fileArr.push(clientLogo);
                    const blobKeyResp = await createBlobKey(fileArr as File[], 'admin');
                    resultantValues.clientLogo.value = blobKeyResp?.[0]?.Uri ? blobKeyResp?.[0]?.Uri : resultantValues.clientLogo.value;
                    resultantValues.clientLogo.isValueUpdated = true
                }
                if (clientHeaderLogo) {
                    const fileArr = [];
                    clientHeaderLogo && fileArr.push(clientHeaderLogo);
                    const blobKeyResp = await createBlobKey(fileArr as File[], 'admin');
                    resultantValues.clientHeaderLogo.value = blobKeyResp?.[0]?.Uri ? blobKeyResp?.[0]?.Uri : resultantValues.clientHeaderLogo.value;
                    resultantValues.clientHeaderLogo.isValueUpdated = true
                }
                if (appIcon) {
                    const fileArr = [];
                    appIcon && fileArr.push(appIcon);
                    const blobKeyResp = await createBlobKey(fileArr as File[], 'admin');
                    resultantValues.appIcon.value = blobKeyResp?.[0]?.Uri ? blobKeyResp?.[0]?.Uri : resultantValues.appIcon.value;
                    resultantValues.appIcon.isValueUpdated = true
                }
                if(loginBanner){
                    const fileArr = [];
                    loginBanner && fileArr.push(loginBanner);
                    
                    const blobKeyResp = await createBlobKey(fileArr as File[], 'admin');
                    
                    resultantValues.loginBanner.value = blobKeyResp?.[0]?.Uri ? blobKeyResp?.[0]?.Uri : resultantValues.loginBanner.value;
                    resultantValues.loginBanner.isValueUpdated = true
                }
                if(appbarBackgroundImage){
                    const fileArr = [];
                    appbarBackgroundImage && fileArr.push(appbarBackgroundImage);
                    const blobKeyResp = await createBlobKey(fileArr as File[], 'admin');
                    resultantValues.appbarBackgroundImage.value = blobKeyResp?.[0]?.Uri ? blobKeyResp?.[0]?.Uri : resultantValues.appbarBackgroundImage.value;
                    resultantValues.appbarBackgroundImage.isValueUpdated = true
                }
                if(loaderGIF){
                    const fileArr = [];
                    loaderGIF && fileArr.push(loaderGIF);
                    const blobKeyResp = await createBlobKey(fileArr as File[], 'admin');
                    resultantValues.loaderGIF.value = blobKeyResp?.[0]?.Uri ? blobKeyResp?.[0]?.Uri : resultantValues.loaderGIF.value;
                    resultantValues.loaderGIF.isValueUpdated = true
                }
                if(loadingBackgroundImage){
                    const fileArr = [];
                    loadingBackgroundImage && fileArr.push(loadingBackgroundImage);
                    const blobKeyResp = await createBlobKey(fileArr as File[], 'admin');
                    resultantValues.loadingBackgroundImage.value = blobKeyResp?.[0]?.Uri ? blobKeyResp?.[0]?.Uri : resultantValues.loadingBackgroundImage.value;
                }
                
                const appSchema = yup.object({ ...appValidationsSchema })
                const validationObject:any = {};
                Object.keys(resultantValues).forEach(key=>{
                    validationObject[key] = resultantValues[key].value;
                })
                
                // await appSchema.validate(validationObject)
                const convertedVals = convertValuesToConfig(resultantValues, appConfig);
                newConfigRef.current.app_configuration = convertedVals;
                setShowConfigPopup(true);
            } catch (err) {
                // Sentry.captureException(err);
                console.log("err===", err)
                if (err instanceof Error)
                    openPopup('Error',"Validation Error occured : " + err?.message)
            }
    }
    const handleCheckChange = (e: React.ChangeEvent<HTMLInputElement>) => {
        const keyName = e.target.name;
        setValues({
            ...values,
            [keyName]: {...values[keyName], value:e.target.checked, isValueUpdated:true} 
        })
    }

    const handleValueChange = (e: React.ChangeEvent<HTMLInputElement>) => {
        const keyName = e.target.name;
        setValues({
            ...values,
            [keyName]: {...values[keyName], value:e.target.value, isValueUpdated:true} 
        })
    }

    const handleSelectValueChange = (e: SelectChangeEvent<unknown>) => {
        const keyName = e.target.name;
        setValues({
            ...values,
            [keyName]: {...values[keyName], value:e.target.value, isValueUpdated:true} 
        })
    }

    const handleColorInputChange = (e: React.ChangeEvent<HTMLInputElement>) => {
        const keyName = e.target.name;
        setValues({
            ...values,
            [keyName]: {...values[keyName], value:e.target.value, isValueUpdated:true} 
        })
        setInputColor({ ...inputColor, [e.target.name]: e.target.value })
      }

    const withoutHash=(result:any)=>{
        const withoutHash = {
            solidAppBarColor: '',
            gradientAppBarColor: '',
            themeColor: '',
        };
        let color: keyof typeof withoutHash;
        for (color in withoutHash) {
          const hexcode = result[color]?.value?.split('#')[1] ? result[color]?.value?.split('#')[1] : result[color].value;
          withoutHash[color] = hexcode;
        }
        return withoutHash;
      }
    useEffect(()=>{
        const withoutHashValues = withoutHash(values);
        setInputColor({ ...withoutHashValues })
      },[values])

    const setAppConfigValues = () => {
        try {
            if (appConfig.length) {
                const result = { ...values } 
                const resValidations = {} as { [key: string]: ReturnType<typeof createValidation> }
                appConfig.forEach((attr) => {
                    resValidations[attr.name] = createValidation(attr)
                    result[attr.name] = attr;
                })
                setValues({ ...result } as appValueTypes);
                setAppValidationSchema({ ...resValidations })
            }
        } catch (err) {
            // Sentry.captureException(err);

        }
    }

    const nameValidation = (name:string):NameValidation =>{
        if(name.includes(" ")){
            return {
                status:"failed",
                message:"Image name should not contain spaces"
            }
        }
        return {
            status:"success",
            message:""
        }
    }

    useEffect(() => {
        setAppConfigValues();
    }, [appConfig])

    
    const importConfiguration = async (importedConfig:any)=>{
        const newConfigs = await overWriteConfig(importedConfig, {
            app_configuration:["clientLogoHeight","loadingBackgroundImage","isAppOffline","clientHeaderLogoHeight","loginBanner","appBarBackgroundType","solidAppBarColor","gradientAppBarColor","appbarBackgroundImage","loadingScreenText","loaderGIF","shareText"]
        })

        newConfigs.forEach((item) => {
            newConfigRef.current[item.domainType] = item.domainValues;
        });
        setShowConfigPopup(true);
    }
    const  onConfigComparatorSuccess=async () => {
        await doFinalConfigSubmit("app_configuration",newConfigRef.current.app_configuration,curConfigRef)
        getAppConfiguration();
    }
    const [importConfigState,setImportConfigState] = useState(false);
     const { translate } = usePortalTranslation();

    return (
        <div className='app_configuration_container'>
            <ConfigurationHeader heading={"App Configuration"} showBackButton={props.showBackButton} saveConfiguration={() => saveConfiguration(false)} />
            <div className="config_form_container">
                <div className="form_header">
                    <BorderHeading>Logo configuration</BorderHeading>
                </div>
                <IndentWrapper indent={0}>
                    <QuestionHeading>
                        {translate(TranslationEnum.ui_config,"Upload the logo you wish to display on the login screen")}  
                    </QuestionHeading>
                    <div className="generic_form_container">
                        <CameraImage nameValidation={nameValidation} maxSize={200} image={clientLogo as string} validHeight={512} validWidth={512} name="clientLogo" setImage={setClientLogo} currImage={values.clientLogo.value} uploadText="Client Logo" />
                        <span className="resolution_text">*{translate(TranslationEnum.ui_config,"The maximum image resolution should be 512x512")}</span>
                        <Button variant="contained" onClick={() => {
                            if (values.clientLogo.value)
                                setValues({ ...values, clientLogo: {...values.clientLogo, value:"",isValueUpdated:true} });
                            setClientLogo(undefined)
                        }}>{translate(TranslationEnum.ui_config,"Remove Image")}</Button>
                    </div>
                </IndentWrapper>

                <IndentWrapper indent={0}>
                    <QuestionHeading>
                       {translate(TranslationEnum.ui_config,"Upload the logo you wish to display on the header")} 
                    </QuestionHeading>
                    <div className="generic_form_container">
                        <CameraImage nameValidation={nameValidation} maxSize={200} image={clientHeaderLogo as string} validHeight={512} maximumWidth={512} name="clientHeaderLogo" setImage={setClientHeaderLogo} currImage={values.clientHeaderLogo.value} uploadText="Client Header" />
                        <span className="resolution_text">*{translate(TranslationEnum.ui_config,"The maximum image resolution should be 512x512")}</span>
                        <Button variant="contained" onClick={() => {
                            if (values.clientHeaderLogo)
                                setValues({ ...values, clientHeaderLogo: {...values.clientHeaderLogo, value:"",isValueUpdated:true} });
                            setClientHeaderLogo(undefined)
                        }}>{translate(TranslationEnum.ui_config,"Remove Image")}</Button>
                    </div>
                </IndentWrapper>

                <IndentWrapper indent={0}>
                    <QuestionHeading>
                        {translate(TranslationEnum.ui_config,"Upload the app icon")} 
                    </QuestionHeading>
                    <div className="generic_form_container">
                        <CameraImage nameValidation={nameValidation} maxSize={200} image={appIcon as string} name="appIcon" setImage={setAppIcon} validHeight={512} validWidth={512} currImage={values.appIcon.value} uploadText="App Icon" />
                        <span className="resolution_text">*{translate(TranslationEnum.ui_config,"The maximum image resolution should be 512x512")}</span>
                        <Button variant="contained" onClick={() => {
                            if (values.appIcon)
                                setValues({ ...values, appIcon: {...values.appIcon, value:"",isValueUpdated:true} });
                            setAppIcon(undefined)
                        }}>{translate(TranslationEnum.ui_config,"Remove Image")} </Button>
                    </div>
                </IndentWrapper>


                {/* <IndentWrapper indent={0}>
                    <QuestionHeading>
                        poweredByLogo
                    </QuestionHeading>
                    <div className="generic_form_container">
                        <CameraImage nameValidation={nameValidation} maxSize={200} image={poweredByLogo as string} name="poweredByLogo" setImage={setAppIcon} validHeight={512} maximumWidth={512} currImage={values.poweredByLogo.value} uploadText="App Icon" />
                        <span className="resolution_text">*{translate(TranslationEnum.ui_config,"The maximum image resolution should be resolution should be 512x512</span>
                        <Button variant="contained" onClick={() => {
                            if (values.poweredByLogo)
                                setValues({ ...values, poweredByLogo: {...values.poweredByLogo, value:"",isValueUpdated:true} });
                            setPoweredByLogo(undefined)
                        }}>Remove Image</Button>
                    </div>
                </IndentWrapper> */}

                <div className="form_header">
                    <BorderHeading>App name configurations</BorderHeading>
                </div>

                <IndentWrapper indent={0}>
                    <QuestionHeading>
                        {translate(TranslationEnum.ui_config,"What should be the name of the app?")} 
                    </QuestionHeading>
                    <div className="answer_container">
                        <Input value={values.appName.value} onChange={handleValueChange} name="appName" />
                    </div>
                </IndentWrapper>

                {/* <IndentWrapper indent={0}>
                    <QuestionHeading>
                        Do you wish the app to be functional offline?
                    </QuestionHeading>
                    <div className="answer_container">
                        <DashboardCheckbox checked={values.isAppOffline} onChange={handleCheckChange} name="isAppOffline" label="Yes" />
                    </div>
                </IndentWrapper> */}

                <IndentWrapper indent={0}>
                    <QuestionHeading>
                        {translate(TranslationEnum.ui_config,"Enter the height of the Login page’s logo")} 
                    </QuestionHeading>
                    <div className="answer_container">
                        <Input value={values.clientLogoHeight.value} type="number" onChange={handleValueChange} name="clientLogoHeight" />
                    </div>
                </IndentWrapper>

                <IndentWrapper indent={0}>
                    <QuestionHeading>
                        {translate(TranslationEnum.ui_config,"Enter the height of the Home page’s header logo")} 
                    </QuestionHeading>
                    <div className="answer_container">
                        <Input value={values.clientHeaderLogoHeight.value} type="number" onChange={handleValueChange} name="clientHeaderLogoHeight" />
                    </div>
                </IndentWrapper>

{/* 
                <div className="form_header">
                    <BorderHeading>Theme configurations</BorderHeading>
                </div>


                <IndentWrapper indent={1}>

                    <QuestionHeading>
                        Enter the hexcode of the Theme Color
                    </QuestionHeading>
                    <div className="color_picker_container">
                        {
                            toggleColorInput?.themeColor ? <span style={{ width: "60%" }}> <Input value={inputColor.themeColor} name={'themeColor'} inputProps={{ maxLength: 6 }} onChange={handleColorInputChange} /></span>
                                :
                                <div><HexColorPicker color={values.themeColor.value} onChange={(newColor) => setValues({ ...values, themeColor: { ...values.themeColor, value: newColor, isValueUpdated: true } })} /> <div style={{ color: values.themeColor.value ? values.themeColor.value : 'black', marginTop: '1rem', fontSize: "1.5rem" }}>{values.themeColor.value}</div></div>
                        }
                        <Picker style={showColorStyle(inputColor.themeColor)} onClick={(e) => setToggleColorInput({ ...toggleColorInput, themeColor: !toggleColorInput.themeColor })} />
                    </div>
                </IndentWrapper> */}

                

                <div className="form_header">
                    <BorderHeading>Header configurations</BorderHeading>
                </div>
                <IndentWrapper indent={1}>
                    <QuestionHeading>
                        {translate(TranslationEnum.ui_config,"Select header background type")} 
                    </QuestionHeading>
                    <div className="answer_container">
                        <DashboardSelect onChange={handleSelectValueChange} value={values.appBarBackgroundType.value} name="appBarBackgroundType" options={appConfig.find(config => config.name === 'appBarBackgroundType')?.possibleVals ? appConfig.find(config => config.name === 'appBarBackgroundType')?.possibleVals : (values.appBarBackgroundType.possibleVals)} selectLableId='Select order calculation type' />
                    </div>
                </IndentWrapper>

                {values.appBarBackgroundType.value==='solid' && (
                    <IndentWrapper indent={2}>
                        <QuestionHeading>
                            {translate(TranslationEnum.ui_config,"Enter the hexcode of the Background Color")} 
                        </QuestionHeading>
                        <div className="color_picker_container">
                        {
                            toggleColorInput?.solidAppBarColor ? <span style={{ width: "60%" }}> <Input value={inputColor.solidAppBarColor} name={'solidAppBarColor'} inputProps={{ maxLength: 6 }} onChange={handleColorInputChange} /></span>
                            :
                            <div><HexColorPicker color={values.solidAppBarColor.value} onChange={(newColor) => setValues({ ...values, solidAppBarColor: {...values.solidAppBarColor, value:newColor,isValueUpdated:true} })} /> <div style={{ color: values.solidAppBarColor.value ? values.solidAppBarColor.value : 'black', marginTop: '1rem', fontSize: "1.5rem" }}>{values.solidAppBarColor.value}</div></div>
                        }
                        <Picker style={showColorStyle(inputColor.solidAppBarColor)} onClick={(e) => setToggleColorInput({ ...toggleColorInput, solidAppBarColor: !toggleColorInput.solidAppBarColor })} />
                        </div>
                    </IndentWrapper>
                    
                    )
                }

                {values.appBarBackgroundType.value==='gradient' && (
                    <IndentWrapper indent={2}>
                        <QuestionHeading>
                            {translate(TranslationEnum.ui_config,"Enter the hexcode of the Background Gradient Color")} 
                        </QuestionHeading>
                        <div className="color_picker_container">
                        {
                            toggleColorInput?.gradientAppBarColor ? <span style={{ width: "60%" }}> <Input value={inputColor.gradientAppBarColor} name={'gradientAppBarColor'} inputProps={{ maxLength: 6 }} onChange={handleColorInputChange} /></span>
                            :
                            <div><HexColorPicker color={values.gradientAppBarColor.value} onChange={(newColor) => setValues({ ...values, gradientAppBarColor: {...values.gradientAppBarColor, value:newColor, isValueUpdated:true} })} /> <div style={{ color: values.gradientAppBarColor.value ? values.gradientAppBarColor.value : 'black', marginTop: '1rem', fontSize: "1.5rem" }}>{values.gradientAppBarColor.value}</div></div>
                        }
                        <Picker style={showColorStyle(inputColor.gradientAppBarColor)} onClick={(e) => setToggleColorInput({ ...toggleColorInput, gradientAppBarColor: !toggleColorInput.gradientAppBarColor })} />
                        </div>
                    </IndentWrapper>
                    
                    )
                }

                {values.appBarBackgroundType.value==='image' && (
                    <IndentWrapper indent={2}>
                    <QuestionHeading>
                        {translate(TranslationEnum.ui_config,"Upload AppBar image")} 
                    </QuestionHeading>
                    <div className="generic_form_container">
                        <CameraImage image={appbarBackgroundImage as string} validHeight={375} validWidth={1024} name="appbarBackgroundImage" setImage={setappbarBackgroundImage} currImage={values.appbarBackgroundImage.value} uploadText="AppBar Image" />
                        <span className="resolution_text">*{translate(TranslationEnum.ui_config,"The maximum image resolution should be 1024x375")}</span>
                        <Button variant="contained" onClick={() => {
                            if (values.appbarBackgroundImage)
                                setValues({ ...values, appbarBackgroundImage: {...values.appbarBackgroundImage, value:"",isValueUpdated:true} });
                                setappbarBackgroundImage(undefined)
                        }}>{translate(TranslationEnum.ui_config,"Remove Image")} </Button>
                    </div>
                </IndentWrapper>
                    
                    )
                }

                <div className="form_header">
                    <BorderHeading>Login Banner</BorderHeading>
                </div>
                <IndentWrapper indent={0}>
                    <QuestionHeading>
                        {translate(TranslationEnum.ui_config,"Upload the Login banner")} 
                    </QuestionHeading>
                    <div className="generic_form_container">
                        <CameraImage image={loginBanner as string} validHeight={540} validWidth={720} name="loginBanner" setImage={setLoginBanner} currImage={values.loginBanner.value} uploadText="Login Banner" />
                        <span className="resolution_text">*{translate(TranslationEnum.ui_config,"The maximum image resolution should be 720x540")}</span>
                        <Button variant="contained" onClick={() => {
                            if (values.loginBanner)
                                setValues({ ...values, loginBanner: {...values.loginBanner, value:'',isValueUpdated:true} });
                                setLoginBanner(undefined)
                        }}>{translate(TranslationEnum.ui_config,"Remove Image")} </Button>
                    </div>
                </IndentWrapper>

                <div className="form_header">
                    <BorderHeading>Loading Screen Configuration</BorderHeading>
                </div>

                <IndentWrapper indent={0}>
                    <QuestionHeading>
                        {translate(TranslationEnum.ui_config,"Upload the launch screen background image")} 
                    </QuestionHeading>
                    <div className="generic_form_container">
                        <CameraImage image={loadingBackgroundImage as string} validHeight={1800} validWidth={1000} name="loadingBackgroundImage" setImage={setLoadingBackgroundImage} currImage={values.loadingBackgroundImage.value} uploadText="Launch screen Background Image" />
                        <span className="resolution_text">*{translate(TranslationEnum.ui_config,"The maximum image resolution should be 1800x1000")}</span>
                        <Button variant="contained" onClick={() => {
                            if (values.loadingBackgroundImage)
                                setValues({ ...values, loadingBackgroundImage:{...values.loadingBackgroundImage,value: ''}});
                                setLoadingBackgroundImage(undefined)
                        }}>{translate(TranslationEnum.ui_config,"Remove Image")} </Button>
                    </div>
                </IndentWrapper>

                <IndentWrapper indent={0}>
                    <QuestionHeading>
                    {translate(TranslationEnum.ui_config,"Upload the launch screen gif")}
                    </QuestionHeading>
                    <div className="generic_form_container">
                        <CameraImage image={loaderGIF as string} validHeight={512} validWidth={512} name="loaderGIF" setImage={setLoaderGIF} currImage={values.loaderGIF.value} uploadText="Loader GIF" />
                        <span className="resolution_text">*{translate(TranslationEnum.ui_config,"The maximum image resolution should be 512x512")}</span>
                        <Button variant="contained" onClick={() => {
                            if (values.loaderGIF)
                                setValues({ ...values, loaderGIF: {...values.loaderGIF, value:''}  });
                            setLoaderGIF(undefined)
                        }}> {translate(TranslationEnum.ui_config,"Remove Image")}</Button>
                    </div>
                </IndentWrapper>

                {/* <IndentWrapper indent={0}>
                    <QuestionHeading>
                    Enter the text that you wish to display on the loading screen
                    </QuestionHeading>
                    <div className="answer_container">
                        <Input value={values.loadingScreenText.value} onChange={handleValueChange} name="loadingScreenText" />
                    </div>
                </IndentWrapper> */}

                {/* <div className="form_header">
                    <BorderHeading>Other Configuration</BorderHeading>
                </div>

                <IndentWrapper indent={0}>
                    <QuestionHeading>
                    Enable privacy policy validation?
                    </QuestionHeading>
                    <div className="answer_container">
                        <DashboardCheckbox onChange={handleCheckChange} checked={values.privacyPolicyValidation.value} name="privacyPolicyValidation" label="Yes" />
                    </div>
                </IndentWrapper>

                <IndentWrapper indent={0}>
                    <QuestionHeading>
                    show suggest product option?
                    </QuestionHeading>
                    <div className="answer_container">
                        <DashboardCheckbox onChange={handleCheckChange} checked={values.isSuggestProductToBeShown.value} name="isSuggestProductToBeShown" label="Yes" />
                    </div>
                </IndentWrapper>


                <IndentWrapper indent={0}>
                    <QuestionHeading>
                    deep link Url
                    </QuestionHeading>
                    <div className="answer_container">
                        <Input value={values.deepLinkUrl.value} onChange={handleValueChange} name="deepLinkUrl" />
                    </div>
                </IndentWrapper>

                <IndentWrapper indent={0}>
                    <QuestionHeading>
                    moengage key
                    </QuestionHeading>
                    <div className="answer_container">
                        <Input value={values.moengageKey.value} onChange={handleValueChange} name="moengageKey" />
                    </div>
                </IndentWrapper>

                <IndentWrapper indent={0}>
                    <QuestionHeading>
                    app sharing message
                    </QuestionHeading>
                    <div className="answer_container">
                        <Input value={values.shareText.value} onChange={handleValueChange} name="shareText" />
                    </div>
                </IndentWrapper>

                <IndentWrapper indent={0}>
                    <QuestionHeading>
                    Play store link
                    </QuestionHeading>
                    <div className="answer_container">
                        <Input value={values.psLink.value} onChange={handleValueChange} name="psLink" />
                    </div>
                </IndentWrapper>

                <IndentWrapper indent={0}>
                    <QuestionHeading>
                    App store Link
                    </QuestionHeading>
                    <div className="answer_container">
                        <Input value={values.appStoreLink.value} onChange={handleValueChange} name="appStoreLink" />
                    </div>
                </IndentWrapper> */}

                

            </div>
            <ImportConfig importConfigState={importConfigState} setImportConfigState={setImportConfigState} configNames={['app_configuration']} importConfigCallback={importConfiguration} />
            <ConfigComparePopup message="Are you sure want to update the config" showConfigPopup={showConfigPopup} setShowConfigPopup={setShowConfigPopup} curConfig={curConfigRef.current} newConfig={newConfigRef.current} onSuccess={onConfigComparatorSuccess} />
        </div>
    )
}

export default AppConfiguration